import { gql } from 'graphql-request';

// =============================================================================
// USER FRAGMENTS
// =============================================================================

export const USER_BASIC_FIELDS = gql`
  fragment UserBasicFields on User {
    id
    name
    secondName
    lastName
    secondLastName
    nickname
    nicknameVisibility
    anonymityMode
  }
`;

export const USER_WITH_COSSY = gql`
  fragment UserWithCossy on User {
    id
    name
    secondName
    lastName
    secondLastName
    nickname
    nicknameVisibility
    cossyId
    neuronId
    duelingBookId
    anonymityMode
  }
`;

export const USER_WITH_COSSY_AND_PICTURE = gql`
  fragment UserWithCossyAndPicture on User {
    id
    name
    secondName
    lastName
    secondLastName
    nickname
    nicknameVisibility
    cossyId
    picture
    anonymityMode
  }
`;

export const USER_WITH_GAME_IDS = gql`
  fragment UserWithGameIds on User {
    id
    name
    secondName
    lastName
    secondLastName
    cossyId
    neuronId
    duelingBookId
    masterDuelId
    duelLinksId
    anonymityMode
    nickname
    nicknameVisibility
  }
`;
